// Pause button for the autoplaying, looping videos (product highlight box / hero,
// highlight box, fullscreen video): moving content longer than 5 s must be
// pausable (WCAG 2.2.2). One button per box, top right; it drives every video in
// the box (desktop and mobile variants). With reduced motion the videos start paused.

const FRAMES = '.son-product-highlight-box, .son-highlight-box, .son-fullscreen-video';

const ICONS = {
    pause: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><rect x="3" y="2" width="3" height="12" fill="currentColor"/><rect x="10" y="2" width="3" height="12" fill="currentColor"/></svg>',
    play: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M4 2l10 6-10 6z" fill="currentColor"/></svg>',
};

function bindVideoPause(frame) {
    if (frame.dataset.sonVideoPauseReady) {
        return;
    }
    const videos = [...frame.querySelectorAll('video[autoplay]')];
    if (!videos.length) {
        return;
    }
    frame.dataset.sonVideoPauseReady = 'true';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'son-video-toggle';
    frame.append(button);

    const render = (paused) => {
        button.innerHTML = paused ? ICONS.play : ICONS.pause;
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        button.classList.toggle('is-paused', paused);
    };

    const setPaused = (paused) => {
        videos.forEach((video) => {
            if (paused) {
                video.pause();
            } else {
                video.play().catch(() => {}); // autoplay blocked (e.g. low power mode): stays paused
            }
        });
        render(paused);
    };

    button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPaused(!button.classList.contains('is-paused'));
    });

    setPaused(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(FRAMES).forEach(bindVideoPause);
});

// the editor renders widgets after DOMContentLoaded, so bind again per element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            $element[0]?.querySelectorAll?.(FRAMES).forEach(bindVideoPause);
        });
    }
});
